import React from 'react';
import NumberFormat, { NumberFormatProps } from 'react-number-format';

const NO_VALUE_TEXT = '-';

type EeTextValueProps = {
  title: string;
  valueClassName?: string;
  value?: string | number;
  formatProps?: NumberFormatProps;
};

export function EeTextValue(props: EeTextValueProps) {
  return (
    <div className="mb-3">
      <div
        className="mb-1"
        style={{ color: 'var(--color-gray)', lineHeight: '12px' }}
      >
        <small className="text-uppercase">{props.title}</small>
      </div>
      <NumberFormat
        displayType="text"
        className={props.valueClassName}
        {...props.formatProps}
        value={props.value ?? NO_VALUE_TEXT}
      />
    </div>
  );
}
